const photoGalleries = {
    _galleries: [],

    init() {
        let self = this;
        if ((document.querySelectorAll('.js-gallery').length === 0) && (document.querySelectorAll('.typography').length === 0)) {
            return;
        }

        const scriptUrls = [
            'https://cdn.jsdelivr.net/npm/lightgallery@2.7.1/lightgallery.min.js',
            'https://cdn.jsdelivr.net/npm/lightgallery@2.7.1/plugins/zoom/lg-zoom.min.js',
            'https://cdn.jsdelivr.net/npm/lightgallery@2.7.1/plugins/thumbnail/lg-thumbnail.min.js'
          ];

        const cssUrl = 'https://cdn.jsdelivr.net/npm/lightgallery@2.7.1/css/lightgallery-bundle.min.css';

        window.initPackages([scriptUrls, cssUrl]).then(() => {
            self._galleriesConstruct();
        }).catch((error) => {
            console.error(error);
        });

    },

    _galleriesConstruct() {
        let self = this;
        let photoGalleries = document.querySelectorAll('.js-gallery');
        let articleGalleries = document.querySelectorAll('.typography');

        if (photoGalleries.length > 0) {
            self._buildPhotoGalleries(photoGalleries)
        }

        if (articleGalleries.length > 0) {
            self._buildArticleGalleries(articleGalleries)
        }
    },

    _buildArticleGalleries(articleGalleries) {
        let self = this;

        articleGalleries.forEach((articleGallery, index) => {
            let items = articleGallery.querySelectorAll('img');
            items.forEach(item => {
                if(item.closest('a')) {
                    item.classList.add('no-resize');
                }

                if(item.closest('.editor-accordion')) {
                    item.classList.add('no-resize');
                }

                if(item.closest('.editor-accordion__icon')) {
                    item.classList.add('no-resize');
                }
            });

            let gallery = lightGallery(articleGallery, {
                selector: articleGallery.querySelectorAll('img:not(.no-resize)'),
                plugins: [lgZoom, lgThumbnail],
                licenseKey: '32088F1F-749D4338-9276BA7C-4A5EF243',
                speed: 500,
                exThumbImage: 'data-external-thumb-image',
            });

            self._galleries.push(gallery);
        });
    },

    _buildPhotoGalleries(photoGalleries) {
        let self = this;

        photoGalleries.forEach((photoGallery, index) => {
            let gallery = lightGallery(photoGallery, {
                selector: photoGallery.querySelectorAll('a'),
                download: true,
                preload: 1,
                licenseKey: '32088F1F-749D4338-9276BA7C-4A5EF243',
                plugins: [lgZoom, lgThumbnail],
                exThumbImage: 'data-external-thumb-image',
            });

            self._galleries.push(gallery);
        });
    },

    destroy() {
        let self = this;
        if (self._galleries.length > 0) {
            self._galleries.forEach((gallery, index) => {
                self._galleries[index].destroy();
            });

            self._galleries = [];
        }
        this.init();
    },
};

photoGalleries.init();

document.addEventListener('LokiRequestEnd', function () {
    photoGalleries.destroy();
});